import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import Icon from '../../components/Icon';
import usePageTitle from '../../hooks/usePageTitle';
import { REGIONS } from '../../data/locations';

export default function Locations() {
  const { t } = useTranslation();
  usePageTitle(t('locations.pageTitle'));

  return (
    <>
      <section className="page-hero">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">{t('locations.eyebrow')}</span>
            <h1>{t('locations.title')}</h1>
            <p className="lede">{t('locations.lede')}</p>
          </Reveal>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="value-grid">
            {REGIONS.map((region, i) => (
              <Reveal key={region.slug} className="value-card" delay={i * 90}>
                <span className="eyebrow">{region.country}</span>
                <h3>{region.name}</h3>
                <p>{region.lede}</p>
                <ul className="check-list" style={{ marginTop: '1.25rem' }}>
                  {region.cities.slice(0, 5).map((city) => (
                    <li key={city}>
                      <span className="check-mark">
                        <Icon name="check" size={14} strokeWidth={2.2} />
                      </span>
                      {city}
                    </li>
                  ))}
                </ul>
                <Link className="btn btn-secondary" to={`/locations/${region.slug}`} style={{ marginTop: '1.25rem' }}>
                  {t('locations.seeRegion', { name: region.name })}
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <Reveal className="cta-band">
            <div>
              <h2>{t('locations.notSureTitle')}</h2>
              <p>{t('locations.notSureBody')}</p>
            </div>
            <div className="cta-actions">
              <Link className="btn btn-primary" to="/contact">{t('locations.contactUs')}</Link>
              <Link className="btn btn-outline" to="/register/family">{t('locations.requestNanny')}</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
